import * as React from 'react';
import { useContext } from 'react';
import { Button } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { MobilePhoneFetcher } from './MobilePhoneFetcher';
import { trackCallButtonClick } from './tracking';
import { TPlaceType } from '../../types/promoDetails/callButton';
import { getPhoneLink } from '../../utils/phone';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';

interface IMobileCallButtonProps {
  placeType: TPlaceType;
}

export const MobileCallButton = ({ placeType }: IMobileCallButtonProps) => {
  const { siteBlockId, builder, offerId, gaLabel, promoInfo } = useContext(PromoOfferCardContext);

  const linkPhone = React.useMemo(() => {
    if (!builder || builder.phones.length === 0) {
      return null;
    }

    return getPhoneLink(builder.phones[0]);
  }, [builder]);

  const [needFetchPhone, setNeedFetchPhone] = React.useState(false);

  const onCallClick = React.useCallback(() => {
    trackCallButtonClick({
      action: 'Open_detail_promo',
      customUrl: gaLabel,
      id: offerId,
      extra: {
        promoId: promoInfo?.uniquePromoId,
        is_price_with_discount: promoInfo?.promoType === 'discount',
      },
    });
    if (siteBlockId) {
      setNeedFetchPhone(true);

      return;
    }

    window.open(linkPhone as string, '_self');
  }, [gaLabel, linkPhone, offerId, siteBlockId, promoInfo]);

  /* istanbul ignore next */
  if (!linkPhone) {
    return null;
  }

  return (
    <>
      <Button
        onClick={onCallClick}
        size="L"
        theme="fill_primary"
        tabIndex={-1}
        fullWidth
        beforeIcon={<IconCommunicationPhone16 color="current_color" />}
      >
        Позвонить застройщику
      </Button>
      {needFetchPhone && <MobilePhoneFetcher placeType={placeType} />}
    </>
  );
};
